import { ActionTree } from 'vuex';
import axios from 'axios';
import { FunctionsState, Functions, RootState } from './functions-types';

export const actions: ActionTree<FunctionsState, RootState> = {
  async getFunctions({ commit }): Promise<any> {
    await axios({ url: 'https://vb0bti0a28.execute-api.ap-south-1.amazonaws.com/poc/mdm-svc/get-function-role' }).then(
      (response) => {
        const payload: Functions = response && response.data;
        commit('setFunctionsInState', payload);
      },
      (error) => {
        console.log(error);
        commit('profileError');
      },
    );
  },
};
